export default __webpack_public_path__ + "static/media/Design_Notifications.ffd8f16c.png";